var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define('score_ccf/XPerience/Actions/ShowAlertMessage',["require", "exports", "./../XPActionBase", "score_ccf/Utils/global"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var XPActionBase_1 = require("./../XPActionBase");
    var global_1 = require("score_ccf/Utils/global");
    var ShowAlertMessage = /** @class */ (function (_super) {
        __extends(ShowAlertMessage, _super);
        function ShowAlertMessage(attribites) {
            return _super.call(this, attribites) || this;
        }
        ShowAlertMessage.prototype.execute = function (component) {
            global_1.default.alert(this.message);
        };
        return ShowAlertMessage;
    }(XPActionBase_1.XPActionBase));
    exports.default = ShowAlertMessage;
});
//# sourceMappingURL=ShowAlertMessage.js.map;
